module.exports = __webpack_public_path__ + "static/cave_fisher-8060293c599c7c635810188b19e5ce4b.jpeg";